import React from "react";

/**
 * Quick Entry's "Transaction created" success card (master-demo-v6.html's
 * `.txn-created` state): Request ID + auto-advance message + a manual
 * "Next Queue Item" button.
 *
 * Extracted from QuickEntryBillingPane (Spec #35135, tidy-first) with no
 * behavioral change - the markup, class names and ids are byte-identical to
 * what that pane rendered inline. Disclosure Accounting (type 66) skips the
 * Billing step entirely (Spec #35135, AC7/AC9) but must show the SAME success
 * card on completion (AC9a), so the card had to stop being private to the
 * billing pane rather than be duplicated.
 */
export interface QuickEntryTransactionCreatedCardProps {
    readonly requestId: string;
    readonly onNextQueueItem?: () => void;
}

const QuickEntryTransactionCreatedCard: React.FC<QuickEntryTransactionCreatedCardProps> = (props) => (
    <div className="txn-created" id="txn-created">
        <div className="txn-created__badge" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                <circle cx={12} cy={12} r={10} />
                <path d="M7 12.5l3 3 7-7.5" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
        </div>
        <h3 className="txn-created__title">Transaction created</h3>
        <div className="txn-created__id">
            Request ID: <strong id="txn-request-id">{props.requestId}</strong>
        </div>
        <p className="txn-created__sub">
            The Request ID is system-generated. Auto-advancing to the next item in the Data Entry queue&hellip;
        </p>
        <button type="button" className="txn-created__next" id="txn-next" onClick={props.onNextQueueItem}>
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={1.8}>
                <path d="M9 5l7 7-7 7" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            Next Queue Item
        </button>
    </div>
);

export default QuickEntryTransactionCreatedCard;
